module.exports = __webpack_public_path__ + "img/mintingBG.c7956afb.png";